import * as React from "react";

interface ToolCallTimeRangeProps {
  startTime?: string | null;
  endTime?: string | null;
  logGroups?: readonly string[] | null;
}

export const ToolCallTimeRange: React.FC<ToolCallTimeRangeProps> = ({
  startTime,
  endTime,
  logGroups
}) => {
  if (!startTime && !endTime && (!logGroups || logGroups.length === 0)) return null;

  return (
    <div className="mb-2 text-xs text-foreground flex flex-wrap gap-2">
      {startTime && (
        <div className="bg-muted border border-border px-2 py-1 rounded">
          <span className="text-primary">From:</span> {startTime}
        </div>
      )}
      {endTime && (
        <div className="bg-muted border border-border px-2 py-1 rounded">
          <span className="text-primary">To:</span> {endTime}
        </div>
      )}
      {logGroups && logGroups.length > 0 && (
        <div className="bg-muted border border-border px-2 py-1 rounded">
          <span className="text-primary">Log Groups:</span> {logGroups.join(", ")}
        </div>
      )}
    </div>
  );
};